export const API_SEARCH_INPUT_DEBOUNCE_TIME = 500;
export const HINT_SHOW_TIME = 5000;

// Unicode symbols for proper typography
export const HYPHEN_MINUS = '\u002D'; // - (ASCII hyphen-minus)
export const MINUS_SIGN = '\u2212'; // − (mathematical minus sign)
export const EM_DASH = '\u2014'; // — (em dash)
export const NON_BREAKING_SPACE = '\u00A0'; //  (non-breaking space)
export const PLUS_SIGN = '\u002B'; // + (ASCII plus)

